import React, { Component } from 'react';
import Tabs from '@tencent/dui/lib/components/Tabs';
import Tooltip from '@tencent/dui/lib/components/Tooltip';
import Snackbar from '@tencent/dui/lib/components/Snackbar';

import { IHistoryManagerInjectable, IShowRecordComponentConfig } from '../history-manager.interface';
import HistoryList from './history-list';
import VersionList from './version-list';
import { SnapshotList, createContinuousClickHandler } from './snapshot-list';
import Style from './index.less';
import i18n from '@i18next/i18n';
import {
    showComponentRecordContent,
    hideComponentRecordContent,
} from '@src/js/common/ark-extensions/dc-components/docs-component-record';
import CommonTips, { CommonTipsType } from '@com/common-tips';
import { tencentDocOpenUrlReload } from '@tencent/tencent_doc_open_url';
import { IExportManager } from '@src/slide/application/service/export-manager/core/interface';
import { IDynamicService } from '@src/slide/infrastructure/module/independent/dynamic-loader/dynamic-service';
import { IAccusationService } from '@src/slide/application/service/accusation-service/core/accusation-service.interface';

export const ActiveType = {
    HISTORY_TYPE: 'history',
    VERSION_TYPE: 'version',
    SNAPSHOT_TYPE: 'snapshot',
} as const;

const VersionAndEditRecordPanelTab = {
    VERSION: 'version',
    EDIT_RECORD: 'edit-record',
};

// TODO: 重构时不熟悉具体业务逻辑，暂时给 any 类型。熟悉这里逻辑的同学麻烦补充一下具体类型
interface IHistoryWrapperProps {
    activeId: any;
    type: any;
    showTab: any;
    isSupportArkVersionManager: boolean;
    exportManager: IDynamicService<IExportManager>;
    accusationService: IDynamicService<IAccusationService>;
    enableHistoryVersion: boolean;
    injectable: IHistoryManagerInjectable;
    getHistorySlide(...args: any): any;
    getColor(...args: any): any;
    revert(...args: any): any;
    getHistory(...args: any): any;
    getVersion(...args: any): any;
    getAuthor(...args: any): any;
    onClose?(): any;
}

// TODO: ditto
interface IHistoryWrapperStates {
    id: string;
    isSnapshotListEnabled: boolean;
}

export default class HistoryWrapper extends Component<IHistoryWrapperProps, IHistoryWrapperStates> {
    private containerElement;
    private handleTitleClick = createContinuousClickHandler(this.enableSnapshotList.bind(this));

    public constructor(props) {
        super(props);
        this.state = {
            id: props.activeId || ActiveType.HISTORY_TYPE,
            isSnapshotListEnabled: false,
        };
    }

    public componentDidMount() {
        if (!this.props.isSupportArkVersionManager) return;

        const options: IShowRecordComponentConfig = {
            defaultTab: this.getDefaultTab(),
            targetDom: this.containerElement,
            onClose: this.onClose.bind(this),
            onEditRecordRevertSuccess: () => {
                this.revertSuccess();
            },
            onEditRecordSelect: (record) => {
                const { rev, fRev, isRevertedVersion } = record;
                let fixedFRev = fRev;
                if (isRevertedVersion || fixedFRev === undefined || record.historyItem.rev_type === 1) {
                    fixedFRev = -1;
                }
                // 某个版本还原而来，不需要fRev
                this.props.getHistorySlide?.(
                    rev,
                    fixedFRev,
                    () => {},
                    () => {
                        Snackbar.show({
                            message: i18n.t('拉取失败'),
                            duration: 2000,
                        });
                    },
                );
            },
            onVersionRevert:
                this.props.injectable.onVersionRevert
                || (() => {
                    this.revertSuccess();
                }),
            onVersionSelect:
                this.props.injectable.onVersionSelect
                || ((version) => {
                    this.props.getHistorySlide?.(
                        version.rev,
                        -1,
                        () => {},
                        () => {
                            Snackbar.show({
                                message: i18n.t('拉取失败'),
                                duration: 2000,
                            });
                        },
                    );
                }),
        };

        showComponentRecordContent(options);
    }

    public render() {
        const { activeId, showTab } = this.props;
        const showPanelId = activeId || ActiveType.HISTORY_TYPE;
        const shouldTabShow = showTab !== false;
        return (
            <div
                className={Style['history-wrapper']}
                ref={(e) => {
                    this.containerElement = e;
                }}
            >
                {!this.props.isSupportArkVersionManager && (
                    <React.Fragment>
                        <div className={Style.header}>
                            <div className={Style.title} onClick={this.handleTitleClick}>
                                {i18n.t('修订记录')}
                            </div>
                            <div className={Style['close-wrapper']}>
                                <Tooltip placement="bottom" title={i18n.t('关闭')}>
                                    <div className={Style.close} onClick={this.onClose.bind(this)}></div>
                                </Tooltip>
                            </div>
                        </div>
                        <div className={Style.border}></div>
                        {shouldTabShow ? (
                            <Tabs
                                className={Style.tabs}
                                tabBarStyle={{ paddingTop: '20px', paddingLeft: '20px' }}
                                tabBarItemStyle={{
                                    color: '#000000',
                                    opacity: '0.64',
                                    padding: '0 4px 8px',
                                    marginRight: '24px',
                                    fontWeight: 500,
                                }}
                                indicatorStyle={{ display: 'none' }}
                                activeItemStyle={{ borderBottom: '2px solid #136AFF', color: '#136AFF', opacity: '1' }}
                                alignment="left"
                                onChange={this.setActiveId.bind(this)}
                                defaultActiveId={showPanelId}
                            >
                                <Tabs.TabPane tab={i18n.t('历史')} id="history" />
                                {this.props.enableHistoryVersion ? (
                                    <Tabs.TabPane tab={i18n.t('版本')} id="version" />
                                ) : (
                                    <span aria-hidden />
                                )}
                                {this.state.isSnapshotListEnabled ? (
                                    <Tabs.TabPane tab={i18n.t('本地备份')} id="snapshot" />
                                ) : (
                                    <span aria-hidden />
                                )}
                            </Tabs>
                        ) : null}
                        <div
                            className={Style['record-list']}
                            style={{ display: this.state.id === ActiveType.HISTORY_TYPE ? 'inline-block' : 'none' }}
                        >
                            <HistoryList
                                showAccusationSupportPage={this.showAccusationSupportPage}
                                getHistorySlide={this.props.getHistorySlide.bind(this)}
                                getColor={this.props.getColor.bind(this)}
                                revert={this.props.revert.bind(this)}
                                getHistory={this.props.getHistory.bind(this)}
                                getAuthor={this.props.getAuthor.bind(this)}
                                showTab={shouldTabShow}
                            />
                        </div>
                        {shouldTabShow ? (
                            <div
                                className={Style['record-list']}
                                style={{ display: this.state.id === ActiveType.VERSION_TYPE ? 'inline-block' : 'none' }}
                            >
                                <VersionList
                                    showAccusationSupportPage={this.showAccusationSupportPage}
                                    getHistorySlide={this.props.getHistorySlide.bind(this)}
                                    getColor={this.props.getColor.bind(this)}
                                    revert={this.props.revert.bind(this)}
                                    getVersion={this.props.getVersion.bind(this)}
                                    showTab={shouldTabShow}
                                />
                            </div>
                        ) : null}
                        <div
                            className={Style['record-list']}
                            style={{ display: this.state.id === ActiveType.SNAPSHOT_TYPE ? 'inline-block' : 'none' }}
                        >
                            <SnapshotList
                                visible={this.state.isSnapshotListEnabled}
                                exportSnapshotFile={async (snapshot) => {
                                    this.props.exportManager.promise().then((exportManager) => {
                                        exportManager.exportSnapshotFile(snapshot);
                                    });
                                }}
                            />
                        </div>
                    </React.Fragment>
                )}
            </div>
        );
    }

    private getDefaultTab() {
        // 由于外面传参用的都是用的旧类型 ActiveType，还有 url 的传参，所以这里就不修改 props.activeId 的参数定义，只是做一层转换到新的类型
        const defaultTab = this.props.injectable.defaultTab || VersionAndEditRecordPanelTab.EDIT_RECORD;
        return this.props.activeId === ActiveType.VERSION_TYPE ? VersionAndEditRecordPanelTab.VERSION : defaultTab;
    }

    private onClose() {
        hideComponentRecordContent();
        this.props.onClose?.();
    }

    private setActiveId(id) {
        this.setState({
            id,
        });
    }

    private revertSuccess = () => {
        CommonTips.getInstance().show({
            message: i18n.t('还原成功'),
            commonTipsType: CommonTipsType.SUCCESS,
            onlyShowOne: true,
        });
        this.props.injectable.deleteSearchParamNotAlreadyCreate();
        setTimeout(() => {
            const shortCircuit = this.props.injectable.onBeforeRevertUrlReload();
            if (shortCircuit) {
                return;
            }
            tencentDocOpenUrlReload();
        }, 1000);
    };

    private enableSnapshotList() {
        this.setState(() => ({ isSnapshotListEnabled: true }));
    }

    private showAccusationSupportPage = (jumpToSubmit?: boolean) => {
        this.props.accusationService.promise().then((accusationService) => {
            accusationService.showSupportPage(jumpToSubmit);
        });
    };
}
